import http from '@/plugins/axios/axios';

export default class PlanoService {

    salvar(requisicao) {       
        return http.post('/api/plano-conta/salvar', requisicao);
    } 

    listarTodos(requisicao) {       
        return http.post('/api/plano-conta/listar-todos', requisicao);
    } 

    listarAtivos(requisicao) {       
        return http.post('/api/plano-conta/listar-ativos', requisicao);
    } 

    buscar(requisicao) {
        return http.post('/api/plano-conta/buscar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/plano-conta/excluir', requisicao);
    } 
}